// The free tools: no account, nothing stored, everything runs in the reader's browser.
import { ArrowUpRight } from "@phosphor-icons/react";
import { Link } from "react-router";

import { useTitle } from "../ui/hooks";
import { PageHero } from "../ui/Section";
import { TOOLS } from "./tools/catalogue";

export function Tools() {
  useTitle("Free tools");
  return (
    <>
      <PageHero kicker="§ Free tools" title={<>Tools for the people, not the vendors.</>}>
        Free to use, no account, and nothing you type leaves your browser. Each one puts a principle of the Charter to work.
      </PageHero>
      <section className="wrap grid gap-5 py-14 md:grid-cols-2">
        {TOOLS.map((t, i) => (
          <Link key={t.to} to={t.to} className="card group flex flex-col p-7 transition-transform hover:-translate-y-1 sm:p-9">
            <div className="flex items-center justify-between">
              <t.Icon weight="duotone" className="h-10 w-10" aria-hidden />
              <span className="font-mono text-sm text-ink3">{String(i + 1).padStart(2, "0")}</span>
            </div>
            <h2 className="mt-10 font-display text-3xl font-bold tracking-tight group-hover:text-signal">{t.name}</h2>
            <p className="mt-2 flex-1 text-[16px] text-ink2">{t.line}</p>
            <span className="mt-6 inline-flex items-center gap-1 font-semibold">
              Open <ArrowUpRight weight="bold" className="h-4 w-4" aria-hidden />
            </span>
          </Link>
        ))}
      </section>
    </>
  );
}
